export function isDesktop() {
    if (Shopify.media_queries.large.matches) {
        return true;
    }
    return false;
}

export function isScreenSizeTablet() {
    if (Shopify.media_queries.tablet.matches) {
        return true;
    }
}
